import type { UnitAdminDto } from "./api/settings";

export interface SettingsUnitGroup {
  id: string;
  name: string;
  code: string;
  units: UnitAdminDto[];
}

export function groupSettingsUnitsByProgramme(
  units: UnitAdminDto[] | undefined,
): SettingsUnitGroup[] {
  if (!units?.length) {
    return [];
  }

  const groups = new Map<string, SettingsUnitGroup>();
  for (const unit of units) {
    let group = groups.get(unit.groupId);
    if (!group) {
      group = {
        id: unit.groupId,
        name: unit.groupName,
        code: unit.groupCode,
        units: [],
      };
      groups.set(unit.groupId, group);
    }
    group.units.push(unit);
  }

  return [...groups.values()].sort((a, b) => a.name.localeCompare(b.name));
}

export function uniqueProgrammeGroups(units: UnitAdminDto[] | undefined) {
  return groupSettingsUnitsByProgramme(units).map(({ id, name, code }) => ({
    id,
    name,
    code,
  }));
}
